import { useState, useRef, useEffect } from "react";
import { NavLink } from "react-router";
import "./NavigationMenu.css";
import { ChevronDownIcon } from "lucide-react";
import {
  FlashcardFeatureIcon,
  HighlightFeatureIcon,
  QuizFeatureIcon,
  StudyFeatureIcon,
  UploadFeatureIcon,
} from "./FeatureIcons";

const NavigationMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  // Function to toggle the menu
  const toggleMenu = () => {
    setIsOpen((prev) => !prev);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current?.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="nav-menu" ref={menuRef}>
      {/* Menu Button */}
      <button className="button menu-button" onClick={toggleMenu}>
        Features
        <ChevronDownIcon className="w-icon-md h-icon-md flex-none" />
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="dropdown-menu">
          <ul>
            <NavLink
              to="/home/upload"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
            >
              <UploadFeatureIcon />
              <div>
                Upload
                <p> Every file you want</p>
              </div>
            </NavLink>
            <NavLink
              to="/home/highlight"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
            >
              <HighlightFeatureIcon color="violet" />
              <div>
                Highlight
                <p> To understand your material</p>
              </div>
            </NavLink>
            <NavLink
              to="/home/flashcard"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
            >
              <FlashcardFeatureIcon />
              <div>
                Generate flashcards
                <p> Quality flashcards in seconds</p>
              </div>
            </NavLink>
            <NavLink
              to="/home/study"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
            >
              <StudyFeatureIcon />
              <div>
                Study effectively
                <p> With spaced repetition</p>
              </div>
            </NavLink>
            <NavLink
              to="/home/quizzes"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
            >
              <QuizFeatureIcon />
              <div>
                Quizzes
                <p> Test your knowledge</p>
              </div>
            </NavLink>
          </ul>
        </div>
      )}
    </div>
  );
};

export default NavigationMenu;
